import React from "react";

/**
 * Fanpuff official wordmark logo (raster, white→purple→magenta with flame flourish).
 * Props:
 *   size         – height in px
 *   glow         – soft neon glow
 */
export default function Logo({ size = 36, glow = true, className = "" }) {
  return (
    <img
      src="/fanpuff-logo.png"
      alt="Fanpuff"
      height={size}
      draggable={false}
      className={`select-none ${className}`}
      style={{
        height: size,
        width: "auto",
        filter: glow ? "drop-shadow(0 0 18px rgba(176,38,255,0.35)) drop-shadow(0 0 22px rgba(255,59,124,0.18))" : "none",
      }}
    />
  );
}
